import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CustomerStoreService } from '../../../services/customer-store.service';
import { ReBaseData } from '../../../../shared/utils/re-base-data';
import { PromoLinkData } from '../../../../shared/molecules/promo-link-wrapper/promo-link-wrapper.component';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'bdo-personal-data-faqs',
    templateUrl: './personal-data-faqs.component.html',
    styleUrls: ['./personal-data-faqs.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PersonalDataFaqsComponent implements OnInit, OnDestroy {
  public accountId: string;
  public companyName: string;
  public promoLinkDataSet: Array<PromoLinkData>;
  protected reBaseData = ReBaseData;
  private subscriptions: Subscription = new Subscription();

  constructor(
    public customerStore: CustomerStoreService,
    private translateService: TranslateService
  ) {
    this.subscriptions.add(this.translateService.onLangChange.subscribe({
      next: () => {
        this.setPromoLinkData();
      }
    }));
   }

  ngOnInit(): void {
    this.accountId = this.customerStore.getAccountId();
    this.companyName = ReBaseData.companyName;
    this.setPromoLinkData();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  setPromoLinkData(): void {
    this.promoLinkDataSet = [
      {
        linkText: this.translateService.instant('personaldata.moreServices.meterreadings'),
        routerUrl: '/zaehlerstand/' + this.accountId
      },
      {
        linkText: this.translateService.instant('personaldata.moreServices.bills'),
        routerUrl: '/dokumente/' + this.accountId
      },
      {
        linkText: this.translateService.instant('personaldata.moreServices.questions'),
        href: ReBaseData.hrefFrequentQuestions
      }
    ];
  }
}
